import React from "react";
import {
  Box,
  Typography,
  useMediaQuery,
  Divider,
} from "@mui/material";
import { styled } from "@mui/material/styles";

// Section容器
const SectionContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

const MobileContact = () => {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");

  const sections = [
    {
      id: 1,
      title: "通过 Zelle 银行转账奉献",
      content: [
        "Zelle ID (电邮): give3cca@gmail.com",
        "请在 Zelle 转账的时候, 注明您的名字及电邮或邮寄地址, 以便我们寄收据给您。谢谢您的支持。",
        "Please indicate your name and email address or mailing address in the Zelle, so we can send out a receipt to you. Thank you for your financial support.",
      ],
      hasQRCode: true,
    },
    {
      id: 2,
      title: "通过支票奉献",
      content: [
        "支票抬头请写 3CCA。支票请寄到2257 Villa Maria Rd N, Claremont, CA 91711。",
        "Please make your check payable to 3CCA, and mail to 2257 Villa Maria Rd N, Claremont, CA 91711.",
        "请注明您的名字及电邮, 以便我们寄收据给您。谢谢您的支持。",
        "Please indicate your email address, so we can send out a receipt to you. Thank you for your financial support.",
      ],
    },
    {
      id: 3,
      title: "免税资格说明",
      content: [
        "我们现在已经可以接受奉献了。我们也已经申请免税资格501(c)(3)，但目前还在等待批准。当我们得到免税资格，我们会即时在此处发布。",
        "We are currently accepting donations. We have applied for tax-exempt status 501(c)(3), but our application is still pending for approval. Any updates to the status will be posted here.",
      ],
    },
    {
      id: 4,
      title: "联系方式",
      content: ["电话: 626 662 4163", "邮箱: 3cchristianalliance@gmail.com"],
    },
  ];

  const textColor = prefersDarkMode ? "#ffffff" : "#000000";
  const secondaryTextColor = prefersDarkMode ? "rgba(235, 235, 245, 0.6)" : "rgba(60, 60, 67, 0.6)";
  const borderColor = prefersDarkMode ? "rgba(84, 84, 88, 0.65)" : "rgba(0, 0, 0, 0.1)";

  return (
    <Box sx={{ px: 2, py: 2.5 }}>
      {/* 页面标题 */}
      <Typography
        variant="h4"
        sx={{
          fontSize: "1.5rem",
          fontWeight: 700,
          color: textColor,
          mb: 3,
          lineHeight: 1.2,
          letterSpacing: "-0.02em",
        }}
      >
        奉献
      </Typography>

      {/* 内容区域 */}
      {sections.map((section, index) => (
        <SectionContainer key={section.id}>
          {/* 章节标题 */}
          <Typography
            variant="h5"
            sx={{
              fontSize: "1.1rem",
              fontWeight: 600,
              color: textColor,
              mb: 1.5,
              lineHeight: 1.3,
              letterSpacing: "-0.01em",
            }}
          >
            {section.title}
          </Typography>

          {/* 章节内容 */}
          <Box>
            {section.content.map((text, textIndex) => (
              <Typography
                key={textIndex}
                sx={{
                  fontSize: "0.85rem",
                  color: textColor,
                  lineHeight: 1.6,
                  mb: 1.25,
                  fontWeight: 400,
                }}
              >
                {text}
              </Typography>
            ))}
          </Box>

          {/* QR码 */}
          {section.hasQRCode && (
            <Box sx={{ mt: 2, mb: 2, textAlign: "center" }}>
              <img
                src="/images/qrcode.png"
                alt="Zelle QR Code"
                style={{
                  width: "180px",
                  height: "180px",
                  borderRadius: "12px",
                  border: `0.5px solid ${borderColor}`,
                }}
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
            </Box>
          )}

          {/* 分隔线（最后一个section不显示） */}
          {index < sections.length - 1 && (
            <Divider
              sx={{
                mt: 2.5,
                borderColor: borderColor,
              }}
            />
          )}
        </SectionContainer>
      ))}
    </Box>
  );
};

export default MobileContact;
